import { useCollection, type UseCollectionOptions } from '@/composables/useDataTableProps';
import { StelleCollection } from '@/models/Stelle';
import type { QueryParams } from '@kp/js-model';

/**
 * Creates a reactive connection between a UserCollection and its params.
 * @see useCollection for more information
 * @returns  an object with the reactive props for this collection, @see useCollection
 */
export function useStelleCollection(options: UseCollectionOptions = {}, queryParams: QueryParams = {}) {
    const stellen = new StelleCollection();
    stellen.setQueryParams(queryParams);
    const initialFilters: ApiFilter[] = [];

    const refs = useCollection(stellen, {
        ...{
            tableSort: [],
            collectionsFilter: initialFilters,
            pageSize: 5
        },
        ...options
    });
    return refs;
}
